// extracted by mini-css-extract-plugin
module.exports = {"title":"SubTitle_title__cWLT5","light":"SubTitle_light__1qyqT","dark":"SubTitle_dark__3eRoR"};